export interface Document {
  unreadCount?: number;
  borrowerEntityId: any;
  borrowerId: any;
  title: string;
  borrowerName: any;
  collateralAddress: any;
  collateralId: any;
  createdBy: string;
  creationDate: Date;
  customDropboxPath: any;
  displayOrder: number;
  priority: string;
  docType: any;
  taskInformation: any;
  taskName: string;
  dropboxPath: any;
  dropboxRev: any;
  keyTask: boolean;
  lastAcceptedBy: any;
  lastAcceptedDate: any;
  manualTask: boolean;
  category: string;
  comments: string;
  lastUpdateDate: Date;
  lastUpdatedBy: string;
  lastUploadBy: any;
  lastUploadDate: any;
  loanTaskId: number;
  loanId: number;
  movedToDropbox: boolean;
  multipleUpload: boolean;
  originalFileName: any;
  requiredForLoanApproval: boolean;
  sectionId: number;
  sectionName: string;
  springcmId: any;
  stage: any;
  status: string;
  streetName: any;
  streetNumber: any;
  synchronizedWithBorrowerDocs: boolean;
  drawId: number;
  // Autocalculated properties
  isForm: boolean;
  canOpenForm: boolean;
  canUploadFile: boolean;
  canDownloadFile: boolean;
  documentNameSecondLine: string;
  isDrawRequestForm: boolean;
  canRequestMoreInformation: boolean;
  parentId: number;
  taskReferenceId: number;
  taskId: number
  taskStatus?: string;
  taskAssignee?: string;
  taskAssignees?: [],
  isTpoRole?: boolean;
  parentTaskId?: number;
  loanProcess: string;
  inspectionId: number;
  payoffId: number;
  taskPriority: string;
  isParentTask: boolean;
  escalated?: string;
  closingCondition?: ClosingCondition;
  postClosingCondition?: PostClosingCondition;
  categoryDisplayName: string;
  taskQueueStatus?: string;
  extensionId?: number;
  parentTask?: boolean;
  displayName?: string;
  readOnly?: boolean;
  internalTask?: boolean;
  resolutionType?: string;
  description?: string;
}

export interface ClosingCondition {
  closingConditionId: number;
  title: string;
  description: string;
  level: number;
}

export interface PostClosingCondition {
  level: number;
  title: string;
  description: string;
}

export interface DocumentSection {
  sectionId: number;
  sectionName: string;
  loanProcess: string;
  displayOrder: number;
  borrowerSection: boolean;
  entitySection: boolean;
  propertySection: boolean;
}

export interface LoanDocument {
  borrowerId: number | null;
  collateralId: number | null;
  customDropboxPath: any;
  taskName: string;
  isMovedToDropbox: boolean;
  loanTaskId: number | null;
  loanId: number;
  requiredForLoanApproval: boolean;
  sectionId: any;
  drawId: number;
  categoryName: string;
}

interface UnreadDocumentsCommentsBySection {
  [key: string]: number;
}

export interface UnreadDocumentsComments {
  totalUnread: number;
  unreadCountBySection: UnreadDocumentsCommentsBySection;
}

export enum DocumentVerificationState {
  NOT_STARTED,
  VERIFIED,
  IN_REVIEW,
  FAILED,
}
